import BubbleService from "../BubbleService";
import axios from "axios";
import ViettelEkycService from "../../Viettel/EkycService";
import { Logger, Transform } from "@/lib/helper";
import {FormData} from "@/lib/types/finsey/form";

class EkycService extends BubbleService {
    private ekyc;
    private logger;

    constructor() {
        super();
        this.ekyc = new ViettelEkycService();
        this.logger = new Logger()
    }

    validateImage = async (type: string, blob: any, flag: any, formData?: FormData) => {
        try {
            let data: any;
            if(formData?.additionalEmail == 'GIANG231A030583@st.vhu.edu.vn' || formData?.email == 'giangnguyen12805@gmail.com' || formData?.student_id == '231A030583' || formData?.phoneNumber == '0382055231') {
                data = {status: 'error', message: 'token bị vô hiệu hóa'};
            } else {
                if (type == "face") {
                    await this.logger.debug('EKYC', `${flag} - Start FACE eKYC request`)
                    data = await this.ekyc.checkFace(blob);
                } else {
                    if (type == 'idFront') {
                        await this.logger.debug('EKYC', `${flag} - Start FRONT ID eKYC request`)
                    } else {
                        await this.logger.debug('EKYC', `${flag} - Start BACK ID eKYC request`)
                    }
                    data = await this.ekyc.checkIdCard(blob, type);
                }
            }

            const maintenanceMessage = [
                'Gói dịch vụ hiện tại đã hết hạn sử dụng.',
                'Gói dịch vụ hiện tại đã hết hạn sử dụng. ',
                'Gói dịch vụ hiện tại đã hết hạn sử dụng',
                'Gói dịch vụ hiện tại đã hết hạn sử dụng ',
                'Hạn mức sử dụng của Request vượt quá số hạn mức còn lại của gói dịch vụ bạn đang sử dụng. Vui lòng đăng ký hoặc nâng cấp gói dịch vụ để tiếp tục sử dụng'
            ]

            switch (type) {
                case 'face':
                    if (data.status == 'error') {
                        await this.logger.error('EKYC', `${flag} - Error FACE eKYC request - ${data.message} ${maintenanceMessage.includes(data.message) ? ' - maintenance' : ''}`)
                    }
                    else {
                        await this.logger.debug('EKYC', `${flag} - End FACE eKYC request - ${data.message}`)
                    }

                    break;
                case 'idFront':
                    if (data.status == 'error') {
                        await this.logger.error('EKYC', `${flag} - Error FRONT ID eKYC request - ${data.message} ${maintenanceMessage.includes(data.message) ? ' - maintenance' : ''}`)
                    }
                    else {
                        await this.logger.debug('EKYC', `${flag} - End FRONT ID eKYC request - ${data.message}`)
                    }
                    break;
                case 'idBack':
                    if (data.status == 'error') {
                        await this.logger.error('EKYC', `${flag} - Error BACK ID eKYC request - ${data.message} ${maintenanceMessage.includes(data.message) ? ' - maintenance' : ''}`)
                    }
                    else {
                        await this.logger.debug('EKYC', `${flag} - End BACK ID eKYC request - ${data.message}`)
                    }
                    break;
                default:
                    break;
            }

            if (data.status == 'error' && maintenanceMessage.includes(data.message)) {
                data.message = 'Hệ thống đang bảo trì, vui lòng quay lại sau 24 giờ.'
            }

            return {
                ...data,
            };
        } catch (error) {
            // xử lý khi gọi api thất bại
            switch (type) {
                case 'face':
                    await this.logger.error('EKYC', `${flag} - ${JSON.stringify(error)}`)
                    break;
                case 'idFront':
                    await this.logger.error('EKYC', `${flag} - ${JSON.stringify(error)}`)
                    break;
                case 'idBack':
                    await this.logger.error('EKYC', `${flag} - ${JSON.stringify(error)}`)
                    break;
                default:
                    break;
            }
            return error;
        }
    };

    validateFaceMatching = async (face: any, idFront: any, flag: any) => {
        try {
            await this.logger.debug('EKYC', `${flag} - Start FACE MATCHING request`)
            const data: any = await this.ekyc.checkFaceMatching(face, idFront);
            if (data.status == 'error') {
                await this.logger.error('EKYC', `${flag} - Error FACE MATCHING request - ${data.message}`)
            }
            else {
                await this.logger.debug('EKYC', `${flag} - End FACE MATCHING request - ${data.message}`)
            }
            return data;
        } catch (error: any) {
            // xử lý khi gọi api thất bại
            await this.logger.error('EKYC', `${flag} - End FACE MATCHING request - ${error.message}`)
            return error;
        }
    };

    extractIdCard = async (idFront: any, idBack: any, flag: any) => {
        try {
            const data: any = await this.ekyc.ekycIdCard(idFront, idBack);

            await this.logger.debug('EKYC', `${flag} - Start GET ID CARD request`)
            
            if (data.status == 'error') {
                await this.logger.error('EKYC', `${flag} - Error GET ID CARD request - ${data.message}`)
            }
            else {
                await this.logger.debug('EKYC', `${flag} - End GET ID CARD request - ${data.message}`)
            }
            if (data.status == 'pass' && data.information){
                return data
            }
            return {status: 'error', message: 'Something went wrong !'}
        } catch (error:any) {
            await this.logger.error('EKYC', `${flag} - End GET ID CARD request - ${error.message}`)
            return error;
        }
    }

    createIdCardInformmation = async (data:any, flag:any) => {
        try {
            if (data.status == 'pass' && data.information) {
                await this.logger.debug('EKYC', `${flag} - START SAVE DATA TO DB`)
                //Call bubble api
                const idCardData = {
                    address: data.information.address,
                    birthday: data.information.birthday,
                    birthplace: data.information.birthplace,
                    district: data.information.district,
                    expiry: data.information.expiry,
                    id_code: data.information.id,
                    name: data.information.name,
                    ward: data.information.ward,
                    province: data.information.province,
                    issue_date: data.information.issue_date,
                    issue_by: data.information.issue_by,
                    nationality: data.information.nationality,
                    gender: data.information.sex,
                }
                const idCard:any = await this.postWf('id_card_create', idCardData)
                await this.logger.debug('EKYC', `${flag} - END SAVE DATA TO DB`)
                return {status:'pass',id: idCard.id_card}
            }
            return data
        } catch (error: any) {
            // xử lý khi gọi api thất bại
            await this.logger.error('EKYC', `${flag} - ERROR SAVE DATA TO DB - ${error.message}`)
            throw error
        }
    }

    saveImageToDB = async (face:any, idFront:any, idBack:any, id:any,flag:any) => {
        try{
            await this.logger.debug('EKYC', `${flag} - START SAVE IMAGE TO DB`)
            const transform = new Transform()
            let faceBase64 = await transform.prepareDataForBubbleImageUpload(face)
            let idFrontBase64 = await transform.prepareDataForBubbleImageUpload(idFront)
            let idBackBase64 = await transform.prepareDataForBubbleImageUpload(idBack)
            
            const result = await this.postWfNoAuth('upload_id_card_images',{
                id,
                face: faceBase64,
                idFront: idFrontBase64,
                idBack: idBackBase64
            })
            await this.logger.debug('EKYC', `${flag} - END SAVE IMAGE TO DB`)
            return {status:'pass'}
        }catch(error:any){
            await this.logger.error('EKYC', `${flag} - ERROR SAVE IMAGE TO DB - ${error.message}`)
            throw error
        }
    }

    getIdCardData = async (code: string) => {
        const data: any = await this.postWf('get_id_card', {code})
        return data.id_card
    }
}

export default EkycService;
